(function () {
  var GOLD = '#D99A3D';
  var RED = '#C44F3C';
  var IVORY = '#FFF8F0';

  function norm(v) {
    return (v || '').toString().replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function allRoots(root, out) {
    out = out || [];
    if (!root || out.indexOf(root) !== -1) return out;
    out.push(root);
    var nodes = [];
    try { nodes = root.querySelectorAll ? root.querySelectorAll('*') : []; } catch(e) { nodes = []; }
    nodes.forEach(function (el) {
      if (el.shadowRoot) allRoots(el.shadowRoot, out);
    });
    return out;
  }

  function judgeRoots() {
    var found = [];
    allRoots(document).forEach(function (root) {
      var candidates = [];
      try {
        candidates = root.querySelectorAll('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-widget, [class*="judge" i], [class*="jdgm" i], [data-widget*="review" i], [aria-label*="review" i]');
      } catch(e) {}
      candidates.forEach(function (el) {
        var text = norm(el.textContent);
        if (text.indexOf('customer reviews') !== -1 || text.indexOf('write a review') !== -1 || text.indexOf('based on') !== -1 || /jdgm|judge/i.test(el.className || '')) {
          if (found.indexOf(el) === -1) found.push(el);
        }
      });
    });
    return found;
  }

  function deepElements(root) {
    var arr=[];
    allRoots(root).forEach(function (r) {
      try { r.querySelectorAll('*').forEach(function(el){ arr.push(el); }); } catch(e) {}
    });
    return arr;
  }

  function hideQuestions(root) {
    deepElements(root).forEach(function (el) {
      var hay = norm(el.textContent) + ' ' + norm(el.getAttribute && el.getAttribute('aria-label')) + ' ' + norm(el.getAttribute && el.getAttribute('title')) + ' ' + norm(el.className && el.className.baseVal ? el.className.baseVal : el.className) + ' ' + norm(el.getAttribute && el.getAttribute('data-action'));
      if (hay.indexOf('ask a question') !== -1 || hay.indexOf('questions') !== -1 || hay.indexOf('question-form') !== -1) {
        if (el.matches && (el.matches('button,a,[role="button"]') || /question/i.test(el.className || ''))) {
          el.style.setProperty('display','none','important');
          el.setAttribute('aria-hidden','true');
        }
      }
    });
  }

  function styleWriteReview(root) {
    deepElements(root).forEach(function (el) {
      if (!el.matches || !el.matches('button,a,[role="button"]')) return;
      var hay = norm(el.textContent) + ' ' + norm(el.getAttribute('aria-label'));
      if (hay.indexOf('write a review') !== -1) {
        el.style.setProperty('display','inline-flex','important');
        el.style.setProperty('align-items','center','important');
        el.style.setProperty('justify-content','center','important');
        el.style.setProperty('min-height','42px','important');
        el.style.setProperty('padding','10px 18px','important');
        el.style.setProperty('border-radius','999px','important');
        el.style.setProperty('background',RED,'important');
        el.style.setProperty('border','1px solid '+RED,'important');
        el.style.setProperty('color',IVORY,'important');
        el.style.setProperty('font-weight','800','important');
        el.style.setProperty('text-transform','uppercase','important');
        el.style.setProperty('letter-spacing','.06em','important');
        el.classList.add('dj-jm-write-review');
      }
    });
  }

  function styleStars(root) {
    deepElements(root).forEach(function (el) {
      var cls = norm(el.className && el.className.baseVal ? el.className.baseVal : el.className);
      var aria = norm(el.getAttribute && el.getAttribute('aria-label'));
      var title = norm(el.getAttribute && el.getAttribute('title'));
      var testid = norm(el.getAttribute && el.getAttribute('data-testid'));
      var star = cls.indexOf('star') !== -1 || aria.indexOf('star') !== -1 || title.indexOf('star') !== -1 || testid.indexOf('star') !== -1;
      if (!star) return;
      el.style.setProperty('color',GOLD,'important');
      el.style.setProperty('opacity','1','important');
      el.style.setProperty('visibility','visible','important');
      el.style.removeProperty('display');
      el.style.setProperty('-webkit-text-fill-color',GOLD,'important');
      if (cls.indexOf('jdgm-star') !== -1) el.style.setProperty('font-family','JudgemeStar','important');
      try {
        el.querySelectorAll('svg,path,polygon,use').forEach(function (p) {
          p.style.setProperty('fill',GOLD,'important');
          p.style.setProperty('stroke',GOLD,'important');
          p.style.setProperty('color',GOLD,'important');
        });
      } catch(e) {}
    });
  }

  function removeMysteryHeaderCircles(root) {
    var rr = root.getBoundingClientRect();
    if (!rr.width || !rr.height) return;
    var maxTop = rr.top + Math.min(360, rr.height * 0.30);

    deepElements(root).forEach(function (el) {
      if (!el.matches || !el.matches('button,a,[role="button"],[tabindex="0"]')) return;
      if (el.classList.contains('dj-jm-write-review')) return;
      var text = norm(el.textContent);
      var aria = norm(el.getAttribute('aria-label'));
      var title = norm(el.getAttribute('title'));
      var cls = norm(el.className && el.className.baseVal ? el.className.baseVal : el.className);
      var testid = norm(el.getAttribute && el.getAttribute('data-testid'));
      var starish = /star|rating/.test(cls + ' ' + aria + ' ' + title + ' ' + testid);
      if (!starish) {
        try {
          starish = !!el.querySelector('[class*="star" i],[aria-label*="star" i],[data-testid*="star" i],[class*="rating" i],[aria-label*="rating" i]');
        } catch(e) {}
      }
      // Judge.me's new widget can render rating stars as empty icon buttons.
      // Never treat a star/rating control as one of the old mystery media circles.
      if (starish) return;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return;
      if (r.top < rr.top || r.top > maxTop) return;
      var squareish = Math.abs(r.width-r.height) <= 14;
      var circleSized = r.width >= 28 && r.width <= 85 && r.height >= 28 && r.height <= 85;
      var empty = text.length === 0 && aria.length === 0 && title.length === 0;
      var mediaControl = /next|previous|gallery|media|photo|video/.test(aria+' '+title);
      if (squareish && circleSized && (empty || mediaControl)) {
        el.style.setProperty('display','none','important');
        el.style.setProperty('visibility','hidden','important');
        el.setAttribute('aria-hidden','true');
        el.setAttribute('tabindex','-1');
      }
    });
  }

  function fixContrast(root) {
    deepElements(root).forEach(function (el) {
      if (!el.matches || !el.matches('h1,h2,h3,h4,h5,p,span,div,a,button')) return;
      if (!norm(el.textContent)) return;
      var cs;
      try { cs=getComputedStyle(el); } catch(e) { return; }
      if (!cs) return;
      var c=cs.color;
      if (c==='rgb(0, 0, 0)' || c==='rgba(0, 0, 0, 1)' || c==='rgb(17, 17, 17)') {
        el.style.setProperty('color',IVORY,'important');
      }
    });
  }

  function clean() {
    judgeRoots().forEach(function (root) {
      styleWriteReview(root);
      hideQuestions(root);
      styleStars(root);
      removeMysteryHeaderCircles(root);
      fixContrast(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean); else clean();
  window.addEventListener('load', clean);
  [200,500,900,1500,2500,4000,7000].forEach(function(ms){ setTimeout(clean,ms); });

  var obs = new MutationObserver(function(){ requestAnimationFrame(clean); });
  obs.observe(document.documentElement,{childList:true,subtree:true});
})();
